// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Grid, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/grid';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_blog-posts.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--blog-posts';
const CAROUSEL_CLASS = 'carousel--blog-posts';
const CAROUSEL_SECTION_SELECTOR = '.blog-posts';
const CAROUSEL_SECTION_CLASS = 'blog-posts';
const CAROUSEL_SCROLLBAR_SELECTOR       = '.swiper-scrollbar';



// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {

        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        const scrollbar = element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR);

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [Navigation, Grid, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1.3,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            pagination: false,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            },

            navigation: {
                nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
            },
            scrollbar: {
                el: scrollbar,
                draggable: true,
            }
        });

        swiper.slides.forEach(function(slide, index) {
            const slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function() {
                swiper.slideTo(index);
            });
        });
    });
